import React, { createContext, useContext, useEffect, useState, useMemo, useCallback } from 'react';

//Helpers
import { setSessionCookie, removeAllCookies, getSessionCookie } from '../helpers/cookies';
import { showMessage } from '../helpers/message';

//API
import setup_api from '../api/setup_api';
import { useDashboard } from './DashboardContext';

function initialContext() {
    return {
        loading: false,
        isSignout: false,
        session: null
    }
}

export const AuthContext = createContext(initialContext());

const AuthProvider = ({ children }) => {
    const {  setDadosDashboardProvider } = useDashboard();
    
    //State para Gerenciar o loading
    const [loading, setLoading] = useState(false);

    //State para gerenciar a autenticação 
    const [session, setSession] = useState(null);

    const [setupVariavel, setSetupVarivel] = useState(null);

    const loadVariaveisSetup = useCallback(() => {
        setup_api.GetVariaveisSetup().then(response => {
            setSetupVarivel(response.data);
        }).catch(e => {
            showMessage("Erro", e.message, "error", null);
        });
    }, []);

    // Função de signIn memoizada para evitar re-renderizações desnecessárias
    const signIn = useCallback(async (data) => {
        await setSessionCookie(data);
        setSession(data);
        setDadosDashboardProvider(null);
    }, []);

    // Função de signOut memoizada
    const signOut = useCallback(async (token) => {
        if (!token) removeAllCookies();
            
        setSession(null);
        setDadosDashboardProvider(null);
    }, []);

    const loadAsync = useCallback(async () => {
        try {
            const data = await getSessionCookie();
            setSession(data);
        } catch (e) {
            setLoading(false);
        }
    }, []);


    // Memoize context value to avoid unnecessary renders
    const contextValue = useMemo(() => ({
        session,
        loading,
        setLoading,
        signIn,
        signOut,
        setupVariavel,
    }), [
        session,
        loading,
        signIn,
        signOut,
        setupVariavel
    ]);

    useEffect(() => {
        loadVariaveisSetup();
        loadAsync();
    }, [
        loadAsync,
        loadVariaveisSetup
    ]);

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    );
};

export function useAuth() {
    return useContext(AuthContext);
}

export default AuthProvider;
